export const FREE_ROBES = [
    7265594540094, 7265596473406, 7265596604478, 7265596964926, 7265596997694,
    40242146738238, 40242161319998, 40242161352766, 40242161385534,
    40242161418302, 40242161516606, 40242161549374, 40242161582142,
    40242162532414, 40242162565182, 40242162597950, 40242162630718,
    40242162663486, 40242162696254, 7322173341758, 40447216025662,
    40447216058430, 40447216091198, 40447216123966, 7292252356670,
    7292253831230, 7292254158910, 7322173341758, 7292247179326, 7292246163518,
    7292248358974, 7292247900222, 7292247900222, 7292247179326, 40314502774846,
    40314502807614, 40314502840382, 40314502873150, 40314502905918,
    40314502938686, 7710316167230, 41436416376894, 41436416409662,
    41436416442430, 7720084832318, 41478439370814, 41478439403582,
    41478439436350,
]

export const SHOW_SOLD_OUT = [
    7643971518526, 7643967258686, 7643967193150, 7643967160382,
]

export const NO_REVIEWS = [
    7520209371198, 7520209469502, 7520209338430, 7520209043518, 7520208977982,
    7145550938174, 7543796662334, 7089025613886, 7655274086462, 7655274217534,
    7655274315838,
]

export const CARD_FOOTER_SLUGS = [
    'all-pajamas',
    'disney-lion-king',
    'disney-moana',
    'easter-shop',
    'eric-carle',
    'halloween',
    'spring-collection',
    'spring-sports',
    'summer-collection',
    'summer-holidays',
]

export const TAGS_ARRAY = ['Buy2Get25', 'Buy3Get30', 'Buy3Get35']

export const PRODUCT_TYPES_40_OFF = ['Swimwear', 'Sun Hats', 'Swim Coverups']

export const PRODUCT_TYPE_ARRAY = [
    'Gift Card',
    'Gift Cards',
    'Specialty SKU',
    'Embroidery Option',
    'Embroidery',
    'Virtual Classes',
    'Classes + Events',
    'Nursery',
    'Cribs',
    'Classes',
    'Strollers',
]

export const TAG_OBJECT = {
    Buy2Get20: 'Buy 2 Get 20% Off',
    Buy2Get25: 'Buy 2 Get 25% Off',
    Buy3Get30: 'Buy 3 Get 30% Off',
    UPF50: 'UPF 50',
}

export const INVALID_PRODUCT_TYPES = [
    'Gift Cards',
    'Gift Card',
    'Specialty SKU',
    'Embroidery Option',
    'Embroidery',
    'Virtual Classes',
    'Classes + Events',
    'Classes',
]

// SWATCH OPTIMIZATION: Complete Swatch System Configuration
export const COMPLETE_SWATCH_SYSTEM = {
    ENABLED: true,
    DEBUG_LOGGING: true,
    FALLBACK_TO_LOADED_DATA: true,
    // Maximum number of swatches to show in UI
    MAX_SWATCHES_DESKTOP: 8,
    MAX_SWATCHES_MOBILE: 4,
    PRELOAD_SWATCH_IMAGES: true,
    FILTER_OUT_OF_STOCK: true,
    // Product types that should be shown even when out of stock
    ALLOW_OUT_OF_STOCK_TYPES: [
        'bundle-builder-product',
        'Virtual Classes',
        'comingsoon'
    ]
}

export const EMBROIDERY_PRICE = 15;
